<script setup lang="ts">
import BaseLayout from '@/components/base/BaseLayout.vue'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'
import AccountInfoSection from '../components/AccountInfoSection.vue'
import PaymentInfoSection from '../components/PaymentInfoSection.vue'

const authStore = useAuthStore()

onMounted(async () => {
  await authStore.getUserInfo()
})
</script>

<template>
  <BaseLayout>
    <div class="my-view">
      <AccountInfoSection />
      <PaymentInfoSection />
    </div>
  </BaseLayout>
</template>

<style scoped>
.my-view {
  max-width: 414px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (max-width: 1365px) {
  .my-view {
    max-width: 600px;
    padding: 16px 20px;
  }
}
</style>
